var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showHeader)?_c('div',{staticClass:"page-header-wrapper"},[_c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"page-title"},[_vm._t("page-title")],2)]),_vm._v(" "),(!_vm.mobile)?_c('v-divider'):_vm._e(),_vm._v(" "),_c('p',{staticClass:"page-subtitle"},[_vm._t("page-subtitle")],2)],1):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79341e00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = null
// module chunks = 